/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chat': {
    width: 16,
    height: 16,
    viewBox: '0 0 81.68 66.24',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M22.9 54.77A40.13 40.13 0 0 0 47 62.36a44.48 44.48 0 0 0 10.52-1.24c2.61-.64 3.56 2.39 16.11 4.38-5.07-5.07-3.85-9.59-1.8-11.23 5.77-4.62 9.3-10.84 9.3-17.68 0-7.53-4.3-14.28-11.11-19"/><path pid="1" class="cls-1" d="M66.39 35.74a20.3 20.3 0 0 0 2.37-9.46C68.77 12 53.48.5 34.63.5S.5 12 .5 26.28C.5 33.12 4 39.34 9.8 44c2.05 1.6 2.14 7-3.6 12.44 14-2.54 15.31-6.27 17.92-5.63a44.48 44.48 0 0 0 10.52 1.24 41.09 41.09 0 0 0 22.06-6.11"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/chat.js